import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/ship-luggage-to-storage-facility.jpg'),
    alt: 'ship luggage to storage facility page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'ship luggage to storage facility page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Ship <span>Luggage</span><span>to Storage Facility Fast</span>',
  description:
    'Secure and hassle-free luggage storage solutions with ShipAndStorage. Easily ship luggage to a storage facility and keep your belongings safe until you need them.',
  image: {
    url: '/images/v2/pages/landing-pages/ship-luggage-to-storage-facility/hero-image.jpg',
    alt: 'Ship Luggage to Storage Facility Fast'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register Now' }
}

export const ourProcessSectionContent = {
  title: 'Secure Luggage Storage Facilities',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Reserve Today' },

  image: {
    url: '/images/v2/pages/landing-pages/ship-luggage-to-storage-facility/secure-luggage-storage-facilities.png',
    alt: 'Secure Luggage Storage Facilities'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Online Booking',
      description:
        'Book your luggage shipment online within minutes. Select your storage duration, provide your shipping details, and receive an instant confirmation for a smooth process.',
      image: {
        src: '/images/v2/pages/common/easy-booking-tracking.png',
        alt: 'Easy Online Booking'
      }
    },
    {
      id: 2,
      title: 'Safe Pickup & Transit',
      description:
        'We partner with leading logistics providers to ensure secure pickup and transit. Your luggage is handled with care and transported safely to our storage facility.',
      image: {
        src: '/images/v2/pages/common/secure-packaging-labeling.png',
        alt: 'Safe Pickup & Transit'
      }
    },
    {
      id: 3,
      title: 'Secure Storage & Retrieval',
      description:
        'Once your luggage arrives, it is stored in a climate-controlled, secure facility. Retrieve your belongings anytime or have them shipped to a new location when needed.',
      image: {
        src: '/images/v2/pages/common/fast-and-reliable-delivery.png',
        alt: 'Secure Storage & Retrieval'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Reliable Storage Facility for Luggage',
  description:
    "ShipAndStorage offers a dependable way to ship luggage to a storage facility with flexible short-term and long-term options. Whether you're a frequent traveler, student, or business professional, our facilities ensure your belongings are safe and easily accessible whenever you need them.",
  image: {
    src: '/images/v2/pages/landing-pages/ship-luggage-to-storage-facility/reliable-storage-facility-for-luggage.jpg',
    alt: 'Reliable Storage Facility for Luggage'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Our Luggage Storage Facilities',

  cards: [
    {
      id: 1,
      title: 'Hassle-Free Travel',
      description:
        'Avoid the inconvenience of carrying heavy luggage. Ship your luggage to a storage facility in advance and enjoy stress-free travel.',
      image: {
        src: '/images/v2/pages/common/hassle-free-travel.png',
        alt: 'Hassle-Free Travel'
      }
    },
    {
      id: 2,
      title: 'Cost-Effective Storage Solutions',
      description:
        'Skip expensive airline baggage fees and high-cost short-term storage. Our affordable shipping and storage services help you save money.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Cost-Effective Storage Solutions'
      }
    },
    {
      id: 3,
      title: 'Flexible Pickup & Delivery',
      description:
        'Need your luggage later? Choose a convenient time for pickup or have it shipped to your new destination when required.',
      image: {
        src: '/images/v2/pages/common/flexible-pickup-delivery.png',
        alt: 'Flexible Pickup & Delivery'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for Luggage Storage Facilities?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Frequent Travelers',
          description:
            'Perfect for those who travel often and need a secure place to store extra luggage while exploring new destinations.'
        },
        {
          id: 2,
          title: 'Students & College Residents',
          description:
            'Ideal for students needing storage between semesters, study abroad programs, or summer breaks. Ship luggage to a storage facility and retrieve it when school resumes.'
        },
        {
          id: 3,
          title: 'Businesses & Professionals',
          description:
            'Keep office supplies, trade show materials, or business-related items in a secure storage facility with easy access whenever needed.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/ship-luggage-to-storage-facility/who-should-choose-us-for-luggage-storage-facilities.jpg',
        alt: 'Who Should Choose Us for Luggage Storage Facilities?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Residential Storage',
      description:
        'Moving, downsizing, or renovating? Ship your luggage to a storage facility for a convenient and stress-free storage solution.',
      image: {
        src: '/images/v2/pages/common/business-furniture-storage.png',
        alt: 'Residential Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Moving Storage',
      description:
        'Need a secure place to store belongings between moves? Our short-term storage solutions help ease the transition.',
      image: {
        src: '/images/v2/pages/common/moving-storage-solution.png',
        alt: 'Moving Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Business Storage',
      description:
        'Store office materials, promotional items, and essential documents safely with flexible business storage options.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'College Storage',
      description:
        'Students can ship luggage to a storage facility during summer or semester breaks and retrieve their belongings when needed.',
      image: {
        src: '/images/v2/pages/common/student-storage-options.png',
        alt: 'College Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Luggage to Storage Facility?',

  image: {
    url: '/images/v2/pages/landing-pages/ship-luggage-to-storage-facility/why-choose-us-for-luggage-to-storage-facility.jpg',
    alt: 'Why Choose Us for Luggage to Storage Facility?'
  },

  articles: [
    {
      id: 1,
      title: 'Safe & Secure Storage',
      description:
        'Our facilities are monitored 24/7, with climate-controlled options to keep your belongings protected.'
    },
    {
      id: 2,
      title: 'Flexible Storage Durations',
      description: 'Store your luggage for a few days, weeks, or months with easy extension options.'
    },
    {
      id: 3,
      title: 'Convenient Pickup & Delivery',
      description: 'We provide seamless doorstep pickup and flexible retrieval options to fit your schedule.'
    },
    {
      id: 4,
      title: 'Reliable Customer Support',
      description: 'Our dedicated team is available to assist with bookings, tracking, and storage inquiries.'
    },
    {
      id: 5,
      title: 'Cost-Effective Solutions',
      description: 'Enjoy affordable storage rates with no hidden fees, making it a budget-friendly choice.'
    },
    {
      id: 6,
      title: 'Global Reach & Nationwide Services',
      description:
        'Ship luggage to a storage facility from anywhere in the U.S. or internationally with trusted logistics partners.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Ship Luggage To Storage Facility Fast And Secure',
  description:
    'Ship luggage to a storage facility fast and securely. Affordable solutions for storing luggage in a reliable storage facility.',
  image: {
    src: '/images/v2/pages/landing-pages/ship-luggage-to-storage-facility/ship-luggage-to-storage-facility-fast-and-secure.png',
    alt: 'Ship Luggage To Storage Facility Fast And Secure'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Book Now' }
}

export const ourPartnersSectionContent = {
  title: 'Trusted Shipping Partners',
  description:
    'We collaborate with leading shipping providers to offer secure and reliable services for your dorm storage needs.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx ensures fast and dependable shipping, making it easy to store and retrieve your items with timely delivery.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference purposes only. FedEx does not guarantee the accuracy or completeness of the information provided. For official details, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL offers international shipping solutions, allowing students to conveniently store and access their belongings worldwide.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference purposes only. DHL does not guarantee the accuracy of the information provided. For official details, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS provides secure and reliable delivery, ensuring your stored items arrive safely at your dorm or residence.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference purposes only. UPS does not guarantee the accuracy or completeness of the information provided. For official details, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
